import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from "@angular/router";
import { EntitiesService } from "@app/core/entities";

export const entityResolver: ResolveFn<any> =
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    return inject(EntitiesService).getEntityById(+route.paramMap.get('id'));
  };